import { AlertsReducer, AlertsConstants, AlertsActionTypes, IncidentListType } from './types';

export const initialState: AlertsReducer = {
  allAlerts: [],
  allIncidents: {} as IncidentListType,
  selectedIncident: {
    name: '',
    last_seen_timestamp: '',
    severity: '',
    is_resolved: false,
    event_count: 0,
    comments_count: 0,
    comments: [],
    recent_failures: '',
    api_location: '',
    resolution_api_location: '',
    previous_incidents: '',
    context_api_location: '',
    comments_api_location: '',
    context_data_api_location: '',
  },
  alertAdminFilters: {
    name: '',
    is_snoozed: false,
    status: [],
  },
  numberOfFilters: 0,
  registerSlugs: [],
  subscribers: [],
  alertConditionCreated: false,
  alertConditionEdited: false,
  alertsError: '',
  isLoading: false,
  isLoadingIncident: false,
};

export function alertsReducer(state: AlertsReducer = initialState, action: AlertsActionTypes) {
  switch (action.type) {
    case AlertsConstants.LoadAllAlerts:
      return {
        ...state,
        allAlerts: action.payload,
      };
    case AlertsConstants.LoadAllIncidents:
      return {
        ...state,
        allIncidents: action.payload,
      };
    case AlertsConstants.LoadAllSubscribers:
      return {
        ...state,
        allSubscribers: action.payload,
      };
    case AlertsConstants.SetSelectedIncident:
      return {
        ...state,
        selectedIncident: action.payload,
      };
    case AlertsConstants.SetRegisterSlugs:
      return {
        ...state,
        registerSlugs: action.payload,
      };
    case AlertsConstants.SetSubscribers:
      return {
        ...state,
        subscribers: action.payload,
      };
    case AlertsConstants.CreateAlertConditionSuccess:
      return {
        ...state,
        alertConditionCreated: true,
      };
    case AlertsConstants.EditAlertConditionSuccess:
      return {
        ...state,
        alertConditionEdited: true,
      };
    case AlertsConstants.ClearEditAlertConditionSuccess:
      return {
        ...state,
        alertConditionEdited: false,
      };
    case AlertsConstants.ClearCreateAlertConditionSuccess:
      return {
        ...state,
        alertConditionCreated: false,
        alertsError: '',
      };
    case AlertsConstants.SetAlertsError:
      return {
        ...state,
        alertsError: action.payload,
      };
    case AlertsConstants.ClearAlertsError:
      return {
        ...state,
        alertsError: '',
      };
    case AlertsConstants.StartLoading:
      return {
        ...state,
        isLoading: true,
      };
    case AlertsConstants.FinishLoading:
      return {
        ...state,
        isLoading: false,
      };
    case AlertsConstants.StartLoadingIncident:
      return {
        ...state,
        isLoadingIncident: true,
      };
    case AlertsConstants.FinishLoadingIncident:
      return {
        ...state,
        isLoadingIncident: false,
      };
    default:
      return state;
  }
}
